/*

class to generate contact point

https://www.hl7.org/fhir/datatypes.html#ContactPoint

{
  "system" : "<code>", // C? phone | fax | email | pager | url | sms | other
  "value" : "<string>", // The actual contact point details
  "use" : "<code>", // home | work | temp | old | mobile - purpose of this contact point
  "rank" : "<positiveInt>", // Specify preferred order of use (1 = highest)
  "period" : { Period } // Time period when the contact point was/is in use
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { CONTACT_POINT_SYSTEM, CONTACT_POINT_USE } = require('@bcm/constants');
const { joiValidateObj } = require('../datastructComponents');

// Create schema
const schema = {
  system: Joi.string().valid( ...Object.keys(CONTACT_POINT_SYSTEM) ).required(),
  value: Joi.string().required(),
  use: Joi.string().valid( ...Object.keys(CONTACT_POINT_USE) ).required(),
  rank: Joi.number().integer().required(),
  periodStart: Joi.string().optional(),
  periodEnd: Joi.string().optional(),
};

// Define class
class ContactPoint {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.ContactPoint = ContactPoint;
exports.contactPointSchema = schema;